import { render, staticRenderFns } from "./secondarycheck.vue?vue&type=template&id=eab12d22&scoped=true&"
import script from "./secondarycheck.vue?vue&type=script&lang=js&"
export * from "./secondarycheck.vue?vue&type=script&lang=js&"
import style0 from "./secondarycheck.vue?vue&type=style&index=0&id=eab12d22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab12d22",
  null
  
)

export default component.exports